module.exports = __webpack_public_path__ + "img/account.cceceb71.svg";